define(function (require) {

    require("ie");

    function post(endpoint, data, next) {

        var xmlhttp = new window.XMLHttpRequest();
        xmlhttp.open("POST", endpoint, true);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.setRequestHeader("Accept", "application/json");

        var postData = serialize(data);

        var handleReadyStateChange = function () {

            if (this.readyState == 4 && this.status == 200) {

                var contentType = (this.getResponseHeader) ? this.getResponseHeader("content-type") : "";
                var result = this.responseText;

                if (contentType.indexOf("application/json") > -1) {
                    var parsedResult = {};
                    try {
                        parsedResult = JSON.parse(result);
                        next(null, parsedResult);
                    }
                    catch (err) {
                        next({ error: err });
                    }
                }
                else {
                    next(null, result);
                }

            }
            else if (this.readyState == 4) {
                next({ status: this.status, body: this.responseText });
            }

        };

        if (xmlhttp.addEventListener) {
            xmlhttp.addEventListener("readystatechange", handleReadyStateChange, false);
        }
        else {
            //console.log("attach event");
            xmlhttp.onreadystatechange = handleReadyStateChange;
        }

        xmlhttp.send(postData);

    }

    var serialize = function(obj, prefix) {
        var str = [];
        for(var p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
                str.push(typeof v == "object" ?  serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }

    return {
        post: post
    };

});



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/ajax.js